import HTTP from '.';
import AccountServiceMock from './mocks/AccountService.mock';
import config from '@/config';

export default class AccountService {
  static forgotPassword(email) {
    if (config.ENV.MOCK === true) {
      return AccountServiceMock.forgotPassword();
    }

    return HTTP.post('/api/Account/ForgotPassword', {
      email,
    });
  }

  static resetPassword(userId, code, password) {
    if (config.ENV.MOCK === true) {
      return AccountServiceMock.resetPassword();
    }

    return HTTP.post('/api/Account/ResetPassword', {
      userId,
      code,
      password,
    });
  }

  static isLoggedIn() {
    if (config.ENV.MOCK === true) {
      return AccountServiceMock.isLoggedIn();
    }

    return HTTP.get('/api/Account/IsLoggedIn', { handleHttpError: false });
  }

  static passwordExpiration() {
    if (config.ENV.MOCK === true) {
      return AccountServiceMock.passwordExpiration();
    }

    return HTTP.get('/api/Account/PasswordExpiration');
  }
}
